import { Box, Typography, useTheme } from "@mui/material";
import React, { ReactElement } from "react";
import { Link } from "react-router-dom";
import BigCar from "../../../../../media/images/icons/bigCar";
import ArrowLeft from "../../../../../media/images/icons/arrow-left";

interface Props {
  title: string;
  icon: ReactElement;
}

export default function LinkCard({ icon, title }: Props) {
  const theme = useTheme();

  return (
    <Link
      to={"/"}
      style={{
        width: "70%",
        borderRadius: "8px",
        marginLeft: "auto",
        marginRight: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: theme.palette.primary.main,
        padding: 16,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        {icon}
        <Typography
          sx={{
            maxWidth: "85%",
            color: "background.default",
          }}
        >
          {title}
        </Typography>
      </Box>

      <ArrowLeft />
    </Link>
  );
}
